import * as actionTypes from "./actionTypes";

export const onPOSTTheTrades = (param, routeToCall, callback = () => {}) => {
  return {
    param,
    routeToCall,
    type: actionTypes.TRADE_POST,
    callback,
  };
};


export const onGETTheTrades = (routeToCall, callback = () => {}) => {
  return {
    routeToCall,
    type: actionTypes.TRADE_GET,
    callback,
  };
};


export const onDummy = (routeToCall, callback = () => {}) => {
  return {
    routeToCall,
    type: actionTypes.TRADE_DUMMY,
    callback,
  };
};

export const onDummyPost = (param, routeToCall, callback = () => {}) => {
  return {
    param,
    routeToCall,
    type: actionTypes.TRADE_DUMMY_POST,
    callback,
  };
};

